import styled, { css } from 'styled-components';

import { TextBlock, BaseText } from '../text';
import { FontFamilyMedium, FontSize10, FontSize18 } from '../fonts';

export const Container = styled.div`
    width: 100%;
    position: relative;
`;

export const BottomLineGrey = styled.div`
    position: absolute;
    height: 2px;
    width: 100%;
    background: ${props => props.theme.color.gray};
`;

export const BottomLineBlack = styled.div`
    position: absolute;
    height: 2px;
    width: 100%;
    background: ${props => props.hasError ? props.theme.color.red : props.theme.color.darkBlue};
    transform-origin: top left;
    transform: ${props => props.isFocused ? 'scale(1)' : 'scaleX(0)'};
    transition: transform 0.3s ease-in-out;
`;

export const ErrorText = styled(TextBlock)`
    ${FontFamilyMedium};
    ${FontSize10};
    color: ${props => props.theme.color.red};
    font-weight: 500;
    margin-top: 4px;
`;

export const LabelInputContainer = styled.div`
    position: relative;
    height: 60px;
`;

export const Label = styled.label`
    position: absolute;
    bottom: 0;
    padding-bottom: 13px;
    z-index: 2;

    ${props => props.hasLeftPadding && 'padding-left: 10px'};

    ${BaseText};
    ${FontSize18};
    color: ${props => props.theme.color[props.labelColor]};
    transform-origin: top left;
    /* translateY(-26) = fontsize(18) + Margin between label and input(8) */
    transform: ${props => props.isFloating ? 'translateY(-26px) scale(0.8)' : 'translateY(0px) scale(1)'};
    transition: transform 0.2s ease-in-out, color 0.2s ease-in-out;
    pointer-events: none;
`;

const InputStyle = css`
    position: absolute;
    bottom: 0;
    width: 100%;
    border: 0px;
    outline: none;

    ${props => props.hasLeftPadding && 'padding-left: 10px;'};

    ${BaseText};
    ${FontSize18};
    padding-bottom: 13px;
    padding-top: 0;
    height: 35px;
    color: ${props => props.theme.color[props.color]};
    margin: 0;
`;

export const Input = styled.input`
    ${InputStyle};
`;

export const InputSelectEditable = styled.input`
    ${InputStyle};
    padding-right: 12px;
    &:hover {
        cursor: pointer;
    }

    ${props => !props.isTextEditable && `
        color: transparent;
        text-shadow: 0 0 0 ${props.theme.color.darkBlue};
        &:focus {
            outline: none;
        }
    `}
`;

export const InputSelect = styled.p`
    ${InputStyle};
    &:hover {
        cursor: pointer;
    }
`;

export const HelperContainer = styled.div`
    position: absolute;
    right: ${props => props.isSelect ? '15px' : '0px'};
    bottom: 0px;
    padding-bottom: 13px;
    display: ${props => props.isVisible ? 'block' : 'none'};
    transition: opacity 0.2s ease-in-out;
    z-index: 2;
    border: none;
    background-color: transparent;

    &:hover {
        cursor: pointer;
    }
`;

export const SuggestedOptionsContainer = styled.div`
    position: absolute;
    top: 100%;
    margin-top: 2px;
    max-height: 200px;
    min-width: 100%;
    overflow-y: scroll;
    border-right: 1px solid ${props => props.theme.color.gray};
    border-bottom: 1px solid ${props => props.theme.color.gray};
    border-left: 1px solid ${props => props.theme.color.gray};
    border-radius: 0 0 10px 10px;
    box-shadow: 0 4px 20px 0 rgba(81, 129, 186, 0.15);
    background-color: white;
    z-index: 100;
`;

export const SelectOption = styled.button`
    border: 0;
    padding: 10px 10px;
    margin: 0;
    display: block;
    cursor: pointer;
    width: 100%;
    ${BaseText};
    text-align: left;
    transition: background-color 0.25s ease-in-out;
    background-color: white;
    &:hover {
        background-color: ${props => props.theme.color.gray};
    }
`;